import { FC, PropsWithChildren } from 'react';

import { useUser } from 'libs/providers';
import { Box, Stack } from 'libs/ui';
import { Icon } from 'libs/ui/Icon';

import { WrapperStyled } from '../Wrapper.styles';

import { HeaderStyled } from './Header.styles';
import { NavigationMenu } from './NavigationMenu';
import { NotificationsFeature } from './NotificationsFeature';
import { User } from './User';

export interface HeaderProps {
  className?: string;
  hideNavigationMenu?: boolean;
  hideNotifications?: boolean;
  hideChangePassword?: boolean;
  isLogoShort?: boolean;
}

export const Header: FC<HeaderProps & PropsWithChildren> = ({
  className,
  hideNavigationMenu,
  hideNotifications,
  hideChangePassword,
  isLogoShort,
}) => {
  const { user } = useUser();

  return (
    <HeaderStyled className={className} hideNavigationMenu={hideNavigationMenu}>
      <WrapperStyled className="header-wrapper">
        <Stack
          alignItems="center"
          className="header-left"
          direction="row"
          flex={1}
          spacing={24}
        >
          <Box>
            {isLogoShort ? (
              <Icon.LogoShort className="header-logoShort" />
            ) : (
              <Icon.Logo className="header-logo" />
            )}
          </Box>
          {!hideNavigationMenu && <NavigationMenu />}
        </Stack>
        <Box className="header-right">
          {user && !hideNotifications && <NotificationsFeature />}
          <User hideChangePassword={hideChangePassword} />
        </Box>
      </WrapperStyled>
    </HeaderStyled>
  );
};
